import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import { EUFlag, WhatsAppIcon, Reveal } from "./Extras";
import { HERO_IMAGE, CATALOG_URL, buildWhatsAppUrl } from "../data/content";

const Hero = ({ config }) => {
    const waUrl = buildWhatsAppUrl(config?.whatsapp, "Hola LoloPets, quiero saber dónde comprar sus productos.");

    return (
        <section id="inicio" data-testid="hero-section" className="relative overflow-hidden bg-brand-cream">
            <div
                className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-brand-magenta/10 blur-3xl"
                aria-hidden="true"
            />
            <div className="mx-auto grid max-w-7xl gap-10 px-4 pb-12 pt-8 sm:px-6 md:pb-16 md:pt-14 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:px-8">
                <div>
                    <Reveal>
                        <span
                            data-testid="hero-eu-badge"
                            className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs font-bold uppercase tracking-widest text-brand-purple shadow-soft"
                        >
                            <EUFlag /> Producto Europeo
                        </span>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h1 className="mt-6 font-display text-4xl font-bold leading-[1.08] tracking-tight text-brand-ink sm:text-5xl lg:text-6xl">
                            La calidad que tus{" "}
                            <span className="text-brand-magenta">pequeñas mascotas</span> merecen
                        </h1>
                    </Reveal>
                    <Reveal delay={0.16}>
                        <p className="mt-6 max-w-xl text-base leading-relaxed text-brand-muted sm:text-lg">
                            Alimentos y complementos para aves, conejos y roedores. Calidad europea,
                            nutrición completa: cada ingrediente tiene una función y un propósito.
                        </p>
                    </Reveal>
                    <Reveal delay={0.24} className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
                        <a
                            data-testid="hero-cta-products"
                            href="#productos"
                            className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full bg-brand-magenta px-8 py-3 font-display font-semibold text-white shadow-soft transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-magentadark hover:shadow-lift"
                        >
                            Ver productos <ArrowRight className="h-4 w-4" />
                        </a>
                        <a
                            data-testid="hero-cta-whatsapp"
                            href={waUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full border-2 border-brand-purple/15 bg-white px-8 py-3 font-display font-semibold text-brand-purple transition-all duration-300 hover:-translate-y-0.5 hover:border-brand-magenta/40 hover:shadow-soft"
                        >
                            <WhatsAppIcon className="h-4 w-4 text-brand-magenta" /> WhatsApp
                        </a>
                    </Reveal>
                    <Reveal delay={0.32}>
                        <a
                            data-testid="hero-cta-catalog"
                            href={CATALOG_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-brand-magenta underline-offset-4 transition-colors duration-200 hover:text-brand-magentadark hover:underline"
                        >
                            <Sparkles className="h-4 w-4" /> Descargar catálogo completo (PDF)
                        </a>
                    </Reveal>
                </div>
                <motion.div
                    initial={{ opacity: 0, scale: 0.96 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="relative"
                >
                    <div className="overflow-hidden rounded-[2rem] rounded-tl-[6rem] shadow-lift">
                        <img
                            src={HERO_IMAGE}
                            alt="Periquitos de colores sobre una rama — LoloPets alimento premium para aves"
                            className="h-64 w-full object-cover sm:h-80 lg:h-[26rem]"
                            loading="eager"
                            fetchpriority="high"
                        />
                    </div>
                    <div className="absolute -bottom-5 -left-3 rounded-2xl bg-white px-5 py-3 shadow-lift sm:-left-6">
                        <p className="font-display text-sm font-bold text-brand-purple">Foody Premium · Smakers</p>
                        <p className="text-xs font-medium text-brand-muted">Nutrición completa por especie</p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default Hero;
